export const ESTIMATE_QUERY_KEYS = {
  ESTIMATE_DEFAULT_TEMPLATE: 'estimateDefaultTemplate',
  ESTIMATE_DEFAULT_SETTINGS: 'estimateDefaultSettings',
  ESTIMATE_SEND_TEMPLATE: 'estimateSendTemplate',
  ESTIMATE_SEND_SETTINGS: 'estimateSendSettings',
  ESTIMATE_EXPIRATION_DATE_SETTINGS: 'estimateExpirationDateSettings',
  ESTIMATE_DEFAULT_MESSAGES: 'estimateDefaultMessages',
  ESTIMATE_PRESENTATION_OPTIONS: 'estimatePresentationOptions',
  ESTIMATE_PRESENTATION_SINGLE_OPTION: 'estimatePresentationSingleOption',
  ESTIMATE_PRESENTATION_IMAGE_UPLOAD_DATA: 'estimatePresentationImageUploadData',
  ESTIMATE_TEMPLATES_GET_TEMPLATES_LIST: 'estimateTemplatesGetTemplateList',
  ESTIMATE_TEMPLATES_GET_CATEGORIES_LIST: 'estimateTemplatesGetCategoriesList',
  ESTIMATE_TEMPLATES_GET_CATEGORY_DATA: 'estimateTemplatesGetCategoryData',
  ESTIMATE_TEMPLATES_GET_TEMPLATE_DATA: 'estimateTemplatesGetTemplateData',
};
